import { AxiosInstance } from 'axios';
import { ChangePasswordParams, CheckSecondPasswordParams } from './UserQueries';
import { UserDTO } from '../../types/apiType';

export default class UserService {
  constructor(private axios: AxiosInstance) {}

  checkSecondPassword = async (value: CheckSecondPasswordParams): Promise<string> => {
    const { data } = await this.axios.post('users/check-second-password', value);
    return data;
  };

  changePassword = async (value: ChangePasswordParams): Promise<string> => {
    const { data } = await this.axios.put('users/change-password', value);
    return data;
  };

  requestOtp = async () => {
    const { data } = await this.axios.post('users/request-otp');
    return data;
  };

  changeSecondPassword = async (value: ChangePasswordParams) => {
    const { data } = await this.axios.put('users/change-second-password', value);
    return data;
  };

  // updateMyDetail = async (params: CreateUserFormParams): Promise<null> => {
  //   const { data } = await this.axios.put('users/me', params);
  //   return data;
  // };

  getMyDetail = async (): Promise<UserDTO> => {
    const { data } = await this.axios.get('users/me');
    return data;
  };

  // getUserExchangeListAdmin = async (params?: GetListUserExchangeParams): Promise<PaginatedConnection<UserExchangeDTO>> => {
  //   const { data } = await this.axios.get('users/exchange-item', { params });
  //   return data;
  // };

  // exchangeItem = async (itemId: string): Promise<null> => {
  //   const { data } = await this.axios.post('users/exchange-item', { itemId });
  //   return data;
  // };

  // updateUserExchange = async (body: { id: string; status: string }): Promise<null> => {
  //   const { data } = await this.axios.put(`users/exchange-item/${body.id}`, { status: body.status });
  //   return data;
  // };

  // updateUserAdmin = async (body: { id: string; params: CreateUserFormParams }): Promise<null> => {
  //   const { data } = await this.axios.put(`users/${body.id}`, body.params);
  //   return data;
  // };

  // createUserAdmin = async (params: CreateUserFormParams): Promise<string> => {
  //   const { data } = await this.axios.post('user', params);
  //   return data;
  // };

  // passVerifyUserAdmin = async (id: string): Promise<null> => {
  //   const { data } = await this.axios.put(`users/pass-verify/${id}`);
  //   return data;
  // };

  // getUserByIdAdmin = async (id: string): Promise<UserDTO> => {
  //   const { data } = await this.axios.get(`users/${id}`);
  //   return data;
  // };

  // getUserListAdmin = async (params?: PaginatedQueryParams): Promise<PaginatedConnection<UserDTO>> => {
  //   const { data } = await this.axios.get('user', { params });
  //   return data;
  // };

  // getUserInfinityListAdmin = async (params: PaginationQueryParams): Promise<PaginationConnection<UserDTO>> => {
  //   const { data } = await this.axios.get('users/infinity', { params });
  //   return data;
  // };

  // deleteUserAdmin = async (id: string): Promise<null> => {
  //   const { data } = await this.axios.delete(`users/${id}`);
  //   return data;
  // };

  // checkIsAddCategoryDefault = async (): Promise<boolean> => {
  //   const { data } = await this.axios.get(`users/check-add-default`);
  //   return data;
  // };

  // updateIsAddCategoryDefault = async (): Promise<null> => {
  //   const { data } = await this.axios.put(`users/check-add-default`);
  //   return data;
  // };
}
